import { render, staticRenderFns } from "./Operario.vue?vue&type=template&id=1e883cbc&"
import script from "./Operario.vue?vue&type=script&lang=js&"
export * from "./Operario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports